var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import { getTodayDeliveryHours } from '../../app/date-helpers';
import RestaurantLocation from './RestaurantLocation';
import RestaurantMenuPageHours from './RestaurantMenuPageHours';
import RestaurantDiscountLabel from './RestaurantDiscountLabel';
import { getAllowedDeliveryOptions } from 'Utils/order';
import { deliveryOptions, DeliveryTypes } from 'App/order-fields';
import YesIcon from 'Icons/YesIcon';
import NoIcon from 'Icons/NoIcon';
import OtoHashTag from 'App/components/common/OtoHashTag';
import { CuisineTypesIconSet } from 'Icons/IconSets';
import RestaurantDeliveryDetails from './RestaurantDeliveryDetails';
import Restaurant from 'Utils/restaurant';
import './restaurant-banner.scss';
import TenantService from 'App/services/tenant';
var RestaurantBanner = function (_a) {
    var basketStatus = _a.basketStatus, children = _a.children, isInIframe = _a.isInIframe, deliveryMode = _a.deliveryMode, onPlace = _a.onPlace, restaurant = _a.restaurant;
    var _b = __read(useState(true), 2), showLogo = _b[0], setShowLogo = _b[1];
    var ordersConfig = Restaurant.getOrdersConfig(restaurant);
    var isTakeout = deliveryMode === DeliveryTypes.takeout;
    var isDelivery = !isTakeout;
    var logo = restaurant.logo;
    var deliveryHours = ordersConfig.deliveryHours;
    var todayDeliveryHours = getTodayDeliveryHours(deliveryHours);
    var isLong = restaurant.name.length > 15;
    var tags = !isInIframe && (React.createElement("div", { className: "restaurant-banner__tags" }, (restaurant.cuisine_label || []).map(function (lbl) { return (React.createElement(OtoHashTag, { key: lbl, className: "d-inline-block", tag: React.createElement(React.Fragment, null,
            CuisineTypesIconSet[lbl] || null,
            " ",
            lbl) })); })));
    var isLanding = !isInIframe;
    return (React.createElement(Row, { className: "flex-column" },
        React.createElement(Col, { className: "restaurant-banner" },
            isLanding && (React.createElement("div", { className: "restaurant-banner__title-wrapper" },
                !!logo && showLogo && (React.createElement("img", { src: "".concat(TenantService.getAssetsDomain(), "/partner-logos/").concat(logo), alt: "logo ".concat(restaurant.name), className: "restaurant-banner__logo", onError: function () { return setShowLogo(false); } })),
                React.createElement("h1", { className: "restaurant-banner__title ".concat(isLong ? 'restaurant-banner__title--long' : '') },
                    React.createElement("span", { className: "restaurant-banner__restaurant-name" }, restaurant.name)))),
            tags,
            isTakeout && (React.createElement(RestaurantLocation, { className: "mb-1", location: restaurant.location })),
            isDelivery && (React.createElement(RestaurantDeliveryDetails, { basketStatus: basketStatus, restaurant: restaurant, wrapperClass: "restaurant-banner__details" })),
            !onPlace && (React.createElement(RestaurantMenuPageHours, { restaurant: restaurant, hours: todayDeliveryHours, options: { iconClassName: 'text-primary', showAllHours: true } })),
            !onPlace && (React.createElement(RestaurantDiscountLabel, { className: "mb-1 mr-1 oto-alert--small", isStatic: true, restaurant: restaurant, fullText: true })),
            React.createElement(RestaurantBannerDeliveryOptions, { ordersConfig: ordersConfig, restaurant: restaurant })),
        React.createElement(Col, null, children)));
};
RestaurantBanner.displayName = 'RestaurantBanner';
export default RestaurantBanner;
var deliveryOptionsWithoutRobot = deliveryOptions.filter(function (opt) { return opt.name !== DeliveryTypes.robot; });
function RestaurantBannerDeliveryOptions(_a) {
    var ordersConfig = _a.ordersConfig, restaurant = _a.restaurant;
    var allowedDeliveries = getAllowedDeliveryOptions(ordersConfig);
    return (React.createElement("div", { className: "restaurant-banner__delivery-options" },
        deliveryOptionsWithoutRobot.map(function (opt) { return (React.createElement("span", { key: opt.name, className: "mr-2" },
            allowedDeliveries.includes(opt) ? (React.createElement(YesIcon, { className: "text-success mr-1" })) : (React.createElement(NoIcon, { className: "text-danger mr-1" })),
            opt.label)); }),
        !!restaurant.robot_discount && (React.createElement(RestaurantDiscountLabel, { className: "my-2", customText: "Dostawa robotem: ".concat(restaurant.robot_discount.label), restaurant: restaurant, isStatic: true }))));
}
